var map = {
	"./cameras.routes.js": 2536,
	"./devices.routes.js": 5485,
	"./grippers.routes.js": 9166,
	"./images.routes.js": 8012,
	"./products.routes.js": 2782,
	"./tasks.routes.js": 6870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4926;